var design =[
    {
        "id": 7,
        "title": "Ultimate Photoshop Training: From Beginner to Pro",
        "author": "Cristian Doru Barin",
        "email": "dorubrain99@gmail.com",
        "description": "Master Photoshop CC 2020 without any previous knowledge with this easy-to-follow course",
        "rating": 4.6,
        "level": "Beginner",
        "lecture": 232,
        "hours": 10,
        "address": {
          "street": "beijing",
          "city": "Japan",
          "geo": {
            "lat": "-67.3159",
            "lng": "21.1496"
          }
        },
        "phone": "123-456-789-00",
        "website": "jonasbrain.com",
        "language": "English",
        "students": 111920,
        "price": 129.99,
        "image": "http://suprkit.com/assets/images/other/course-13.jpg",
      }, 
      {
        "id": 8,
        "title": "Ultimate Web Designer & Developer Course: Build 23 Projects!",
        "author": "Brad Hussey",
        "email": "hussey3099@gmail.com",
        "description": "Become a Full-Stack Developer - Learn Everything from Design to Front & Back-End Programming.",
        "rating": 4.4,
        "level": "Master",
        "lecture": 100,
        "hours": 12,
        "address": {
          "street": "new york",
          "city": "united state",
          "geo": {
            "lat": "-17.3159",
            "lng": "51.1496"
          }
        },
        "phone": "123-456-789-00",
        "website": "bradhussey.com",
        "language": "English",
        "students": 65790,
        "price": 134.99,
        "image": "http://suprkit.com/assets/images/other/course-14.jpg",
      }, 
      {
        "id": 9,
        "title": "The Ultimate Web Designing Course in Photoshop",
        "author": "Supriyo kundu",
        "email": "supriyokundu30@gmail.com",
        "description": "Learn Web Designing in Photoshop step by step (Over 20 PSD Files, 3 Mega Web Design Projects Included)",
        "rating": 3.9,
        "level": "All",
        "lecture": 111,
        "hours": 9,        
        "address": {
          "street": "new york",
          "city": "united state",
          "geo": {
            "lat": "-17.3159",
            "lng": "51.1496"
          }
        },
        "phone": "123-456-789-00",
        "website": "supriyokundu.com",
        "language": "English",
        "students": 112790,
        "price": 99.99,
        "image": "https://img-a.udemycdn.com/course/480x270/1430746_2f43_9.jpg",
      },  
      {
        "id": 10,
        "title": "UI & Web Design using Adobe Illustrator CC",
        "author": "Daniel Walter Scott",
        "email": "waltescot20@gmail.com",
        "description": "Build professional web & app designs using Adobe Illustrator CC",
        "rating": 4.1,
        "level": "All",
        "lecture": 109,
        "hours": 7,
        "address": {
          "street": "new york",
          "city": "united state",
          "geo": {
            "lat": "-27.3159",
            "lng": "11.1496"
          }
        },
        "phone": "123-456-789-00",
        "website": "walterscot.com",
        "language": "English",
        "students": 444790,
        "price": 299.99,
        "image": "http://suprkit.com/assets/images/other/course-3.jpg",
      },   
      {
        "id": 11,
        "title": "Learn Adobe After Effects CC 2019 for Beginners",
        "author": "Jordy Vandeput",
        "email": "vandeput2019@gmail.com",
        "description": "Dive in the world of Visual Effects in this exciting and themed hands-on course",
        "rating": 4.3,
        "level": "Beginner",
        "lecture": 321,
        "hours": 25,        
        "address": {
          "street": "california",
          "city": "united kingdom",
          "geo": {
            "lat": "-47.3159",
            "lng": "21.1496"
          }
        },
        "phone": "123-456-789-00",
        "website": "Vandeputvisual.com",
        "language": "English",
        "students": 1176,
        "price": 99.99,
        "image": "http://suprkit.com/assets/images/other/course-1.jpg",
      }, 
      {
        "id": 12,
        "title": "Adobe Premiere Pro CC: Complete A Video Editing Project",
        "author": "Life Progression Project",
        "email": "progression@yahoo.com",
        "description": "We supply the footage and audio! Learn how to edit an engaging video using Adobe Premiere Pro CC from start to finish",
        "rating": 4.7,
        "level": "All",
        "lecture": 111,
        "hours": 11,        
        "address": {
          "street": "california",
          "city": "united kingdom",
          "geo": {
            "lat": "-27.3159",
            "lng": "11.1496"
          }
        },
        "phone": "123-456-789-00",
        "website": "Progressionlearnt.com",
        "language": "English",
        "students": 5229,
        "price": 145.99,
        "image": "http://suprkit.com/assets/images/other/course-9.jpg",
      },
      {
        "id": 19,
        "title": "Photoshop Training: For Become Pro",
        "author": "Saidul Islam",
        "email": "saidulislam20@gmail.com",
        "description": "Master Photoshop CC 2020 without any previous knowledge with this easy-to-follow course",
        "rating": 4.4,
        "level": "Beginner",
        "lecture": 80,
        "hours": 10,        
        "address": {
          "street": "comilla",
          "city": "united kingdom",
          "geo": {
            "lat": "-47.3159",
            "lng": "21.1496"
          }
        },
        "phone": "123-456-789-00",
        "website": "smbondfb.com",
        "language": "English",
        "students": 22900,
        "price": 120.50,
        "image": "https://img-a.udemycdn.com/course/480x270/1046722_cbd7_2.jpg",
      }                        
]

export default design;